import { locales } from '@constants/accountsPayableLink';

export const formatPhoneNumber = (phoneNumber: string | number): string => {
  const format = /^(\d{3})(\d{3})(\d{4})$/;
  return String(phoneNumber).replace(/[^\d]/g, '').replace(format, '($1) $2 $3');
};

export const formattedAmount = (value: number | string, currency: string) =>
  Intl.NumberFormat(locales[currency as keyof typeof locales], {
    style: 'currency',
    currency,
  }).format(+value);

export const formatClabe = (clabe: string | number): string => {
  // 549 583 75212948092 4
  const format = /^(\d{3})(\d{3})(\d{11})(\d{1})$/;
  return String(clabe).replace(/[^\d]/g, '').replace(format, '$1 $2 $3 $4');
};
